import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null
    }),

    getters: {
        isAuthenticated: (state) => !!state.token,
        getToken: (state) => state.token,
        getUser: (state) => state.user
    },

    actions: {
        setToken(token) {
            this.token = token;
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },

        setUser(user) {
            this.user = user;
            localStorage.setItem('user', JSON.stringify(user));
        },

        async login(credentials) {
            try {
                const response = await axios.post('login', credentials);
                
                if (response.data.token) {
                    this.setToken(response.data.token);
                    this.setUser(response.data.user);
                }
                return response;
            } catch (error) {
                throw error;
            }
        },

        async logout() {
            try {
                await axios.post('logout', {}, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                });
            } catch (error) {
                console.error('Logout API call failed:', error);
            } finally {
                this.token = null;
                this.user = null;
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                delete axios.defaults.headers.common['Authorization'];
            }
        },

        // Initialize auth state from localStorage
        initializeAuth() {
            const token = localStorage.getItem('token');
            const user = JSON.parse(localStorage.getItem('user'));
            
            if (token) {
                this.setToken(token);
            }
            if (user) {
                this.setUser(user);
            }
        }
    }
}); 